import { useEffect, useState } from "react";
import { useLocation, useRouteError } from "react-router-dom";
import { LanguageProvider, useLanguage } from "@/contexts/LanguageContext";
import { isChunkLoadError, recoverChunkLoadError } from "@/lib/chunkRecovery";
import { buildLocalizedPath } from "@/lib/i18n";

const RouteErrorContent = () => {
  const error = useRouteError();
  const { pathname, search, hash } = useLocation();
  const { t, language } = useLanguage();
  const [recovering, setRecovering] = useState(() => isChunkLoadError(error));
  const destination = pathname + search + hash;

  useEffect(() => {
    // Router has committed the requested URL now. A preload-error listener
    // would run earlier and could reload the page the visitor was leaving.
    setRecovering(recoverChunkLoadError(error, destination));
  }, [error, destination]);

  return (
    <main className="field-page min-h-screen">
      <div className="field-wrap py-24" role="alert">
        <p className="field-label">Fluxabee</p>
        <h1 className="mt-6 max-w-3xl text-3xl font-semibold leading-tight sm:text-5xl">
          {t(recovering ? "field.error.updating" : "field.error.title")}
        </h1>
        <p className="mt-6 max-w-xl text-muted-foreground">
          {t(recovering ? "field.error.updatingDescription" : "field.error.description")}
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-6">
          <a href={destination} className="field-button">
            {t("field.error.reload")}
          </a>
          <a href={buildLocalizedPath("/", language)} className="field-text-link">
            {t("field.error.home")}
          </a>
        </div>
      </div>
    </main>
  );
};

// This eager boundary replaces Layout, including its context providers.
export const RouteErrorBoundary = () => (
  <LanguageProvider>
    <RouteErrorContent />
  </LanguageProvider>
);
